import 'modern-normalize/modern-normalize.css'
import React from 'react'
import { Router } from 'react-static'
import { injectGlobal, ThemeProvider } from 'styled-components'
import { hot } from 'react-hot-loader'
import Routes from 'react-static-routes'
import { Footer, Navigation, Box, Flex } from 'components'
import theme from './theme'

injectGlobal`
  color: ${theme.colors.gray[0]};
  html, body, #root { height: 100%; }
  body {
    font-family: 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial,
      'Lucida Grande', sans-serif;
    font-weight: 300;
    font-size: 16px;
    margin: 0;
    padding: 0;
  }
  img {
    max-width: 100%;
  }
  a {
    text-decoration: none;
    color: ${theme.colors.primary[0]};
    :hover {
      color: ${theme.colors.primary[1]};
    }
    :active {
      color: ${theme.colors.primary[2]};
    }
    font-weight: bold;
  }
  h1, h2, h3, h4, h5, h6 {
    color: ${theme.colors.gray[0]};
    letter-spacing: .05rem;
    margin-left: -2px;
  }
  strong, b {
    font-weight: 700;
  }
  *::selection {
    background: ${theme.colors.primary[0]};
    color: white;
  }
`

const App = () => (
  <Router>
    <ThemeProvider theme={theme}>
      <Flex flexDirection="column" justifyContent="space-between" style={{ height: '100%' }}>
        <Box>
          <Navigation />
          <Box className="content">
            <Routes />
          </Box>
        </Box>
        <Box>
          <Footer />
        </Box>
      </Flex>
    </ThemeProvider>
  </Router>
)

export default hot(module)(App)



// WEBPACK FOOTER //
// /opt/build/repo/src/App.js